import * as z from 'zod';

// Environment variables must be strings.
export const envVarsSchema = z.record(z.string(), z.coerce.string());
